import React, { FC } from "react";
import Drawer from "shared/components/Drawer";
import { useThemeTagsPage } from "../../context";
import ActionButton from "./components/ActionButton";
import Tabs from "./components/Tabs";
import General from "./components/Tabs/Content/General";
import Translations from "./components/Tabs/Content/Translations";
import { ThemeTagDetailsProvider, useThemeTagDetails } from "./context";
import { TagDetailsTabs } from "./context/types";
import TagDetailsSkeleton from "./skeleton";

const ThemeTagDetailsContainer: FC = () => (
  <ThemeTagDetailsProvider>
    <ThemeTagDetails />
  </ThemeTagDetailsProvider>
);

const ThemeTagDetails: FC = () => {
  const { themeTagsDetailsDrawer } = useThemeTagsPage();
  const { selectedTab, loading, onCloseTagDetails } = useThemeTagDetails();

  const title = themeTagsDetailsDrawer.drawerDetails
    ? "Edit tag"
    : "Add new tag";

  const TAB_CONTENT: Record<TagDetailsTabs, FC> = {
    [TagDetailsTabs.General]: General,
    [TagDetailsTabs.Translations]: Translations,
  };

  const ContentComponent = TAB_CONTENT[selectedTab];

  return (
    <Drawer
      title={title}
      isOpen={themeTagsDetailsDrawer.isOpen}
      onCloseDrawer={onCloseTagDetails}
      headingRight={<ActionButton />}
      headingBottom={<Tabs />}
    >
      {loading && <TagDetailsSkeleton />}
      {!loading && <ContentComponent />}
    </Drawer>
  );
};

export default ThemeTagDetailsContainer;
